import { put, takeLatest, call, all } from 'redux-saga/effects';
import types from '../../types';
import api from '../../../services/api';
import notification from '../../../services/notification';

// GET WITHDRAWALS LIST
function* getPending({ payload }) {
  try {
    const { data, status } = yield call(api.transfer.getPending, payload);
    if (status < 200 || status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.GET_PENDING_SUCCESS, payload: data });
  } catch (error) {
    yield put({ type: types.GET_PENDING_FAILURE });
    if (error?.response?.status === 401) return;
    notification({ type: 'error', message: 'Something went wrong' });
  }
}

// PUT WITHDRAWALS APPROVE
function* approve({ payload, pagination, setIsDisabled }) {
  try {
    const { status } = yield call(api.transfer.putPending, payload);
    if (status < 200 || status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.APPROVE_PENDING_SUCCESS });
    setIsDisabled(false);
    yield put({ type: types.GET_PENDING_START, payload: pagination });
  } catch (error) {
    yield put({ type: types.APPROVE_PENDING_FAILURE });
    setIsDisabled(false);
    if (error?.response?.status === 401) return;
    // if (error?.response?.data?.errors.includes('not_enough_funds_on_hot_wallet')) {
    //   notification({ type: 'error', message: 'Not enough money' });
    // } else {
    //   notification({ type: 'error', message: 'Something went wrong' });
    // }
    if (error?.response?.data?.errors?.length) {
      notification({ type: 'error', message: error?.response?.data?.errors?.[0] });
    } else {
      notification({ type: 'error', message: 'Something went wrong' });
    }
  }
}

// PUT WITHDRAWALS REJECT
function* reject({ payload, pagination, setIsDisabled }) {
  try {
    console.log('PUT WITHDRAWALS REJECT', payload);
    const { status } = yield call(api.transfer.putPending, payload);
    if (status < 200 || status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.REJECT_PENDING_SUCCESS });
    setIsDisabled(false);
    yield put({ type: types.GET_PENDING_START, payload: pagination });
  } catch (error) {
    yield put({ type: types.REJECT_PENDING_FAILURE });
    setIsDisabled(false);
    if (error?.response?.status === 401) return;
    // notification({ type: 'error', message: 'Something went wrong' });
    if (error?.response?.data?.errors?.length) {
      notification({ type: 'error', message: error?.response?.data?.errors?.[0] });
    } else {
      notification({ type: 'error', message: 'Something went wrong' });
    }
  }
}

export function* pending() {
  yield all([
    yield takeLatest(types.GET_PENDING_START, getPending),
    yield takeLatest(types.REJECT_PENDING_START, reject),
    yield takeLatest(types.APPROVE_PENDING_START, approve),
  ]);
}
